import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import Modal from '../../../shared/components/ui/Modal';
import { shortCloseOrder } from '../../services/api/implementation/impl';

// POs in these states can't be short-closed (the server refuses too).
export const PO_CLOSED_STATUSES = ['Material received', 'Short closed'];

export const canShortClose = (order) =>
  !!order && !order.short_closed_at && !PO_CLOSED_STATUSES.includes(String(order.status || ''));

/** Confirm + optional reason, then POST /orders/:id/short-close. */
const ShortCloseModal = ({ orderId, onClose, onDone }) => {
  const [reason, setReason] = useState('');

  const mutation = useMutation({
    mutationFn: () => shortCloseOrder(orderId, reason.trim()),
    onSuccess: () => {
      toast.success(`PO #${orderId} closed`);
      onDone?.();
      onClose();
    },
    onError: (err) =>
      toast.error(err?.response?.data?.message || err?.message || 'Could not close the PO')
  });

  return (
    <Modal name={`Short-close PO #${orderId}?`} width={35} onClose={onClose}>
      <p className="text-sm text-gray-700">
        Nothing more will be received on this PO. Material still shown in transit is cleared. This
        can&apos;t be undone.
      </p>
      <label className="mt-4 block text-sm">
        <span className="mb-1 block text-gray-600">Reason (optional)</span>
        <input
          type="text"
          maxLength={255}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="e.g. Vendor can't supply the rest"
          className="w-full rounded border-[1px] border-stone-300 p-2"
        />
      </label>
      <div className="mt-4 flex justify-end gap-3 border-t pt-4">
        <button
          type="button"
          className="rounded-md border border-gray-300 px-4 py-2 text-sm text-gray-700"
          onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          disabled={mutation.isPending}
          className="rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
          onClick={() => mutation.mutate()}>
          {mutation.isPending ? 'Closing…' : 'Short-close PO'}
        </button>
      </div>
    </Modal>
  );
};

export default ShortCloseModal;
